/**
 * Input with Postfix Icon Renderer
 *
 * Text input with an icon positioned at the end (right side)
 */

import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FieldRenderer } from '@/MyCode/core';

/**
 * Input Postfix Icon Renderer
 * Features:
 * - Icon on the right side
 * - Supports any Lucide icon via renderIcon
 * - Error states
 * - Custom input types
 */
export const renderInputPostfixIcon: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    renderIcon,
    isRequired
}) => (
    <div className="space-y-2">
        <Label htmlFor={field.name}>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <div className="relative">
            <Input
                id={field.name}
                type={field.inputType || 'text'}
                placeholder={field.placeholder}
                value={value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
                maxLength={field.maxLength}
                className={`peer pe-9 ${hasError ? 'border-destructive' : ''}`}
            />
            <div className="pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-muted-foreground/80 peer-disabled:opacity-50">
                {renderIcon(field.ui?.icon)}
            </div>
        </div>
    </div>
);

export default renderInputPostfixIcon;
